import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8","key":"svg-0"}],["path",{"d":"M18 20v-17","key":"svg-1"}],["path",{"d":"M15 6l3 -3l3 3","key":"svg-2"}]]

const IconArrowAutofitUp = createReactComponent('outline', 'arrow-autofit-up', 'ArrowAutofitUp', __iconNode);

export default IconArrowAutofitUp;